export enum Cookies {
  IB_AB_TEST_GROUP = 'ib_ab_test_group',
  IB_AB_SEARCH = 'ib_ab_search',
  IB_TRANSACTION_TIME = 'ib_transaction_time',
  IB_ACTIVITY_TIME = 'ib_activity_time',
  IB_UTM_CAMPAIGN = 'ib_utm_campaign',
  IB_UTM_MEDIUM = 'ib_utm_medium',
  IB_UTM_SOURCE = 'ib_utm_source',
  IB_UTM_DATE_TIME = 'ib_utm_date_time',
  IB_REFERRAL = 'ib_referral',
  GCLID = 'gclid',
  IB_DIRECT_DATE_TIME = 'ib_direct_date_time',
  LOGIN_ATTEMPT = 'login_attempt',
  INDIAMART_MEDIUM = 'indiamart_medium',
  IB_ADMITAD_UID = 'ib_admitad_uid',
  CF_POSTAL_CODE = 'cf-postal-code',
  CF_COUNTRY = 'cf-country',
  PINCODE = 'pincode',
}
